import { useNavigate, useLocation } from 'react-router-dom'

import { RoleType } from '@tribeplatform/gql-client/types'
import {
  SystemSpaceSlug,
  useAuthToken,
  useSpaceUtil,
} from '@tribeplatform/react-sdk/hooks'

export const useLogin = () => {
  const { data: authToken } = useAuthToken()
  const isGuest =
    !authToken?.role?.type || authToken?.role?.type === RoleType.guest
  const location = useLocation()
  const navigate = useNavigate()
  const { generatePath } = useSpaceUtil()

  const showLogin = () => {
    if (!isGuest) {
      return false
    }
    navigate(
      generatePath(
        SystemSpaceSlug.LOGIN,
        null,
        location?.pathname
          ? { redirect: encodeURIComponent(location.pathname) }
          : null,
      ),
    )
  }

  const isLoggedIn = !isGuest

  return {
    showLogin,
    isLoggedIn,
  }
}
